module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lXQIy"))).then(() => parcelRequire('1iHdE'));